module.exports = __webpack_public_path__ + "static/smartbox-065d7df8663bf7fe3cd7e37c28372430.jpg";